export function normalizeRating(value) {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    const rating = Number(value);

    return Number.isInteger(rating) && rating >= 1 && rating <= 10 ? rating : null;
}

export function ratingToStars(value) {
    const rating = Number(value);

    return Number.isFinite(rating) ? rating / 2 : null;
}

export function formatStarRating(value, fractionDigits = 1) {
    const stars = ratingToStars(value);

    if (stars === null) {
        return '';
    }

    return stars.toFixed(fractionDigits).replace(/\.0$/, '');
}

export function formatRatingLabel(value) {
    const rating = normalizeRating(value);

    return rating === null ? '' : `${rating}/10 · ${formatStarRating(rating)}★`;
}
